import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const AmazonPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.AMAZON_PAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.AMAZON_PAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.AMAZON_PAY)} alt="amazon-pay" />
    </Box>
  );
};
